import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconFile({
  extColor,
  isAutoscallable = false,
  sizeKey = '38x38',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38 38"
      fill="none"
    >
      <path
        d="M22.1668 3.1665H9.50016C8.66031 3.1665 7.85486 3.50013 7.26099 4.094C6.66713 4.68786 6.3335 5.49332 6.3335 6.33317V31.6665C6.3335 32.5064 6.66713 33.3118 7.26099 33.9057C7.85486 34.4995 8.66031 34.8332 9.50016 34.8332H28.5002C29.34 34.8332 30.1455 34.4995 30.7393 33.9057C31.3332 33.3118 31.6668 32.5064 31.6668 31.6665V12.6665L22.1668 3.1665Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1665 3.1665V12.6665H31.6665"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3332 20.5835H12.6665"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3332 26.9165H12.6665"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8332 14.25H14.2498H12.6665"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
